import { Button } from "@component/button";
import RejectionIcon from "@component/rejection-icon";
import { Company } from "@type/company";

interface Props {
    company: Company | undefined
}

function ApplicationRejection({ company }: Props) {
    return (
        <div className="max-w-2xl mx-auto">
            <div
                className="bg-white dark:bg-gray-900 rounded-3xl p-8 border border-gray-100 dark:border-gray-800 text-center"
                style={{ border: "0px solid transparent", boxShadow: '0px 0px 0px #000000, 0px 4px 30px -4px rgba(0, 0, 0, 0.3)' }}
            >
                <RejectionIcon className={`mx-auto mb-6`} />

                <h1 className="text-2xl font-bold mb-2">
                    Application Unsuccessful
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-lg mx-auto whitespace-pre-line">
                    Thank you for applying. While this role wasn’t the right fit, we’ll keep your profile on file for future opportunities with{" "}
                    <span className={`font-bold text-blue-600`}>
                        {company?.company_name || "ourteam"}
                    </span>
                    .
                </p>

                <div
                    className={`mx-auto p-4 rounded-lg border mb-5 bg-red-50 border-red-700`}
                >
                    <h2 className={`text-lg font-medium mb-3 text-red-700 text-left`}>
                        What happens next?
                    </h2>
                    <ul className={`text-left space-y-3 text-sm m-0 text-red-700`}
                    >
                        <li className="flex items-start gap-3 m-0">
                            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-100 text-red-700 text-xs font-medium flex-shrink-0`}
                            >
                                1
                            </span>
                            The application will now be automatically completed.
                        </li>
                        <li className="flex items-start gap-3 m-0">
                            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-100 text-red-700 text-xs font-medium flex-shrink-0`}
                            >
                                2
                            </span>
                            Browse new roles that better match your skills.
                        </li>
                        <li className="flex items-start gap-3 m-0">
                            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-100 text-red-700 text-xs font-medium flex-shrink-0`}
                            >
                                3
                            </span>
                            Upskill and update your profile regularly to improve future
                            job matches.
                        </li>
                    </ul>
                </div>

                <Button
                    variant="default"
                    className="bg-blue-600"
                    onClick={() => {
                        window.location.href = "/dashboard";
                    }}>
                    Explore More Opportunities
                </Button>
            </div>
        </div>
    );
}

export default ApplicationRejection